import React from 'react';
import Fab from '@mui/material/Fab';

export default (props) => (
    <Fab {...props} variant="extended">
        {props.children}
    </Fab>
);